const inset = {
  sm: '5px 12px',
  md: '5px 16px',
  lg: '9px 16px',
};

export default inset;
